// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__33Lam","footer":"ModalInfo_footer__3lENx"};